import _slicedToArray from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import moment from 'moment';
import { getCurrentSubscriptionFromService, getQuery } from '../../utils/helpers';
import { Information } from '../Information';
import { useRouter } from 'next/router';
import { ServiceProspectConfirmation } from '../ServiceProspectConfirmation';
import { ProviderServicePageHead } from '../ProviderService/PageHead';
import { ReferredHeader } from '../ReferredHeader';
import { ServiceProfile } from '../ServiceProfile';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ProviderServicePageContainer = function ProviderServicePageContainer(_ref) {
  var providers = _ref.providers,
      defaultProvider = _ref.defaultProvider,
      providerService = _ref.providerService,
      serviceProspect = _ref.serviceProspect,
      loading = _ref.loading,
      loadingAuth = _ref.loadingAuth,
      serviceProspectVerificationSent = _ref.serviceProspectVerificationSent,
      activeTab = _ref.activeTab,
      confirmServiceProspect = _ref.confirmServiceProspect,
      currentUser = _ref.currentUser,
      subscriptions = _ref.subscriptions,
      referrerUser = _ref.referrerUser,
      referralProgram = _ref.referralProgram,
      createServiceProspect = _ref.createServiceProspect,
      schedules = _ref.schedules,
      posts = _ref.posts,
      getSchedule = _ref.getSchedule,
      getPosts = _ref.getPosts,
      activeReferralProgram = _ref.activeReferralProgram,
      isServiceCustomer = _ref.isServiceCustomer,
      planWaitlistIds = _ref.planWaitlistIds;
  var router = useRouter();
  var query = router.query;
  var providerSlug = getQuery(query.providerSlug);

  var _Object$values$filter = Object.values(providers).filter(function (p) {
    return p.slug === providerSlug;
  }),
      _Object$values$filter2 = _slicedToArray(_Object$values$filter, 1),
      stateProvider = _Object$values$filter2[0];

  var provider = stateProvider || defaultProvider;
  var token = getQuery(query.token);
  var innerRedirect = getQuery(query.innerRedirect);
  var providerServiceId = providerService === null || providerService === void 0 ? void 0 : providerService.id;

  var _useState = useState({
    posts: false,
    sessions: false
  }),
      tabVisibility = _useState[0],
      setTabVisibility = _useState[1];

  useEffect(function () {
    if (token && providerService && !serviceProspectVerificationSent) {
      confirmServiceProspect({
        serviceId: providerService.id,
        token: token,
        provider: provider,
        skipNotification: !!innerRedirect
      }).then(function () {
        if (!innerRedirect) return;
        router.replace(innerRedirect);
      });
    }
  }, [token, providerService, serviceProspectVerificationSent]);
  useEffect(function () {
    if (providerServiceId) {
      getSchedule({
        serviceId: providerServiceId,
        startsAt: moment().toISOString(),
        endsAt: moment().add(3, 'month').toISOString()
      });
      getPosts(providerServiceId);
    }
  }, [providerServiceId]);
  useEffect(function () {
    setTabVisibility({
      posts: posts.length > 0,
      sessions: schedules.length > 0
    });
  }, [schedules, posts]);

  if (!provider && (loadingAuth || loading)) {
    return /*#__PURE__*/_jsx("div", {
      className: "flex flex-column items-center justify-center h-fill",
      children: /*#__PURE__*/_jsx(Information, {
        heading: "Loading..."
      })
    });
  }

  var sessionTab = tabVisibility.sessions && 'sessions';
  var postsTab = tabVisibility.posts && 'posts';
  var isTabSelected = !!activeTab;
  var tab = activeTab ? activeTab : sessionTab || postsTab;
  return /*#__PURE__*/_jsxs("div", {
    className: classNames('w-fill overflow-auto', {
      'h-fill': !providerService
    }),
    children: [providerService && !getCurrentSubscriptionFromService(subscriptions, providerService.id) && /*#__PURE__*/_jsx(ReferredHeader, {
      referrerUser: referrerUser,
      referralProgram: referralProgram
    }), providerService && provider && /*#__PURE__*/_jsx(ProviderServicePageHead, {
      provider: provider,
      providerService: providerService
    }), serviceProspect && !serviceProspectVerificationSent ? /*#__PURE__*/_jsx(ServiceProspectConfirmation, {
      providerService: providerService,
      provider: provider
    }) : providerService && provider && /*#__PURE__*/_jsx(ServiceProfile, {
      provider: provider,
      providerService: providerService,
      createServiceProspect: createServiceProspect,
      currentUser: currentUser,
      schedules: schedules,
      posts: posts,
      activeTab: tab,
      isTabSelected: isTabSelected,
      activeReferralProgram: activeReferralProgram,
      isServiceCustomer: isServiceCustomer,
      planWaitlistIds: planWaitlistIds
    })]
  });
};